var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#BDFF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 26.92V29.92C32.0012 30.1985 31.9441 30.4742 31.8326 30.7294C31.721 30.9845 31.5574 31.2136 31.3521 31.4019C31.1469 31.5901 30.9046 31.7335 30.6408 31.8227C30.377 31.9119 30.0974 31.9451 29.8201 31.92C26.7429 31.5856 23.7871 30.5342 21.1901 28.85C18.7739 27.3147 16.7254 25.2662 15.1901 22.85C13.5 20.2412 12.4483 17.271 12.1201 14.18C12.0951 13.9035 12.1279 13.6248 12.2166 13.3616C12.3052 13.0985 12.4476 12.8567 12.6348 12.6516C12.822 12.4466 13.0499 12.2827 13.3038 12.1705C13.5578 12.0583 13.8324 12.0003 14.1101 12H17.1101C17.5954 11.9952 18.0658 12.1671 18.4338 12.4835C18.8018 12.8 19.0421 13.2395 19.1101 13.72C19.2367 14.6801 19.4715 15.6227 19.8101 16.53C19.9446 16.8879 19.9737 17.2769 19.894 17.6509C19.8142 18.0249 19.6289 18.3681 19.3601 18.64L18.0901 19.91C19.5136 22.4136 21.5865 24.4865 24.0901 25.91L25.3601 24.64C25.6319 24.3711 25.9752 24.1859 26.3492 24.1061C26.7231 24.0263 27.1121 24.0555 27.4701 24.19C28.3773 24.5286 29.32 24.7634 30.2801 24.89C30.7658 24.9585 31.2095 25.2032 31.5266 25.5775C31.8437 25.9518 32.0122 26.4296 32.0001 26.92Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1fb73105d1b61ecaa0f499478ec38cd5.svg";
export { ForwardRef as ReactComponent };